//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {};
  },

  created() {
    // if(this.controlItem && this.controlItem.HelperText){
    //   this.RightIcon = "question-o";
    //   console.log("this.RightIcon",this.RightIcon);
    // }
  },

  methods: {

    async doEvent(){

      var $e = this.$cmd.checkEvent(this.controlItem,"OnChange");
      if (!$e) return;

      var $cmd = $e.Cmd;
      if (!$cmd) return;

      var url = $cmd.CommandText;
      await this.$parent.$repostForm(url);
      return;

    },
    

    onInput(value) {
      //console.log("onInput---value",value);
    },

    async onBlur(event) {
      console.log("onBlur---onBlur", event);
      this.doEvent();
    },

    onHelpIconClick() {
      if (this.controlItem && this.controlItem.HelperText) {
        this.$msg.toast(this.controlItem.HelperText);
      } else {
        this.$msg.toast("没有找到帮助信息");
      }
    }
  }
};
